export enum EExportFormat {
  A4 = 'A4',
  LETTER = 'LETTER',
  A3 = 'A3',
  LEGAL = 'LEGAL',
}
